import { read, write, erase } from '../smartpak/cookie';
import { AUTO_APPLY_PROMO_COOKIE_NAME } from './constants';

const delimiter = ',';

const promoStore = {
    get: function () {
        const current = read(AUTO_APPLY_PROMO_COOKIE_NAME);
        return current ? current.split(delimiter) : [];
    },
    set: function (value) {
        let val = Array.isArray(value) ? value : [value];

        return write(AUTO_APPLY_PROMO_COOKIE_NAME, val.join(delimiter), 31);
    },
    clear: function () {
        return erase(AUTO_APPLY_PROMO_COOKIE_NAME);
    }
};

export default promoStore;